import React from "react";
import clsx from "clsx";

import { Button } from "components";

import { ReactComponent as CancelIcon } from "static/images/cancel.svg";
import { ReactComponent as CheckDone } from "static/images/checked.svg";
import { ReactComponent as EditIcon } from "static/images/pencil.svg";
import styles from "./tableEditButtons.module.scss";

type TableEditButtonsProps = {
	isEditMode: boolean;
	setEditMode?: any;
	disabledEditButton?: boolean;
	disabledActionsButton?: boolean;
	disabledSubmitButton?: boolean;
	isReverted?: boolean;
};

export const TableEditButtons = ({
	isEditMode,
	setEditMode,
	disabledEditButton = false,
	disabledActionsButton = false,
	disabledSubmitButton = false,
	isReverted,
}: TableEditButtonsProps) => {
	const classNameIsReverted = isReverted ? styles.isReverted : "";
	return isEditMode ? (
		<div className={clsx(styles.positionRelative, classNameIsReverted)}>
			<Button
				onClick={e => {
					e.stopPropagation();
					setEditMode(false);
				}}
				icon={<CancelIcon />}
				btnIcon
				variant="secondary-danger"
				size="sm"
				title="Cancel"
				className={styles.cancelButton}
				disabled={disabledActionsButton}
			/>
			<Button
				type="submit"
				icon={<CheckDone />}
				btnIcon
				variant="secondary"
				size="sm"
				title="Save"
				disabled={disabledSubmitButton || disabledActionsButton}
			/>
		</div>
	) : (
		<Button
			onClick={e => {
				e.stopPropagation();
				setEditMode(true);
			}}
			icon={<EditIcon />}
			btnIcon
			disabled={disabledEditButton}
			variant="secondary"
			size="sm"
			title="Inline edit"
		/>
	);
};
